import React from 'react';
import { Icon } from 'merchant-portal-components';

const ChevronLeftIcon = (props) => (
  <Icon className="fa fa-chevron-left" {...props} />
);

export default ChevronLeftIcon;
